import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { LoadingSpinner } from '@tw/tw-component-library';
import { CentralizedRequestsPage } from './CentralisedRequestsPage';
import { CentralizedFormPage } from './CentralisedFormPage';

export const CentralizedWorkflowRouter: React.FC = () => {
  return (
    <Suspense fallback={<LoadingSpinner variant="fullPage" />}>
      <Routes>
        {/* Route for the list of requests for a specific workflow */}
        <Route path=":workflowKey" element={<CentralizedRequestsPage />} />

        {/* Route for creating a new request for a specific workflow */}
        <Route path=":workflowKey/new" element={<CentralizedFormPage />} />

        {/* Route for editing an existing request for a specific workflow */}
        <Route path=":workflowKey/:id" element={<CentralizedFormPage />} />

        {/* Fallback route for any other paths under /workflows/* */}
        <Route
          path="*"
          element={
            <div>
              <h2>Workflow Page Not Found</h2>
              <p>
                The specific workflow page you're looking for doesn't exist.
              </p>
            </div>
          }
        />
      </Routes>
    </Suspense>
  );
};
